import { render, staticRenderFns } from "./PurExD_Export.vue?vue&type=template&id=012395da"
import script from "./PurExD_Export.vue?vue&type=script&lang=js"
export * from "./PurExD_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports